import { useEffect } from 'react'

import { NOTES_V2_MENTIONS } from '@disco/constants/FeatureTypes'
import {
  useGetNotesUnreadQuery,
  useMarkNotesViewedMutation,
} from '@disco/state-management/api/discussions'
import { getConstanceSetting } from '@disco/state-management/selectors/user'

import type { DiscussionVisibility } from 'types/discussion'
import type { TrackId } from 'types/track'

import { useSelector } from 'hooks/use-redux'

type Props = {
  trackId: TrackId
  visibility: DiscussionVisibility
}

/**
 * Marks the track's internal notes as viewed (clearing its dot) while the
 * Internal Notes tab is showing. Renders nothing; mounts only when the Notes
 * tab is active. Gated behind NOTES_V2_MENTIONS.
 */
const NotesViewedMarker = ({ trackId, visibility }: Props): null => {
  const enabled = useSelector(state =>
    Boolean(getConstanceSetting(state, NOTES_V2_MENTIONS)),
  )
  const [markViewed] = useMarkNotesViewedMutation()
  const { data: unread } = useGetNotesUnreadQuery(trackId, { skip: !enabled })

  // `unread` is a dep so a live reply that re-lights the dot on the already-open
  // Internal tab clears it again, instead of sticking until remount.
  useEffect(() => {
    if (enabled && visibility === 'internal' && unread) {
      markViewed({ track_id: trackId })
    }
  }, [enabled, visibility, trackId, unread, markViewed])

  return null
}

export default NotesViewedMarker
